import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { type Locale, useLocaleStore } from '@/shared/store/localeStore'

import en from './locales/en.json'
import es from './locales/es.json'

/**
 * Idioma de arranque: el de la URL si es una ruta en inglés (`/en`, `/en/*`) — así la primera
 * pintura ya sale en su idioma y no pisa el HTML prerenderizado —; si no, el guardado.
 */
function initialLanguage(): Locale {
  const path = typeof window === 'undefined' ? '' : window.location.pathname
  return path === '/en' || path.startsWith('/en/') ? 'en' : useLocaleStore.getState().locale
}

void i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
  lng: initialLanguage(),
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
})

/**
 * i18next sigue al store. Se compara con el ÚLTIMO idioma pedido, no con `i18n.language`: si el
 * store cambia dos veces seguidas (es → en → es) mientras un `changeLanguage` está en curso,
 * `i18n.language` aún tiene el valor viejo y la segunda petición se perdería, dejando i18next y
 * el store desalineados.
 */
let requestedLanguage: string = i18n.language
useLocaleStore.subscribe((state) => {
  if (state.locale !== requestedLanguage) {
    requestedLanguage = state.locale
    void i18n.changeLanguage(state.locale)
  }
})

export default i18n
